export default "/images/vendor/flag-icon-css/flags/4x3/ws.svg?a6817aa95b8cdf652ba6f8c60527188d";